import { createPermission } from '@backstage/plugin-permission-common';

export const llmProxyLocaldevKeyReadPermission = createPermission({
  name: 'llmProxy.localdevKey.read',
  attributes: { action: 'read' },
});

export const llmProxyLocaldevKeyCreatePermission = createPermission({
  name: 'llmProxy.localdevKey.create',
  attributes: { action: 'create' },
});

export const llmProxyLocaldevKeyRotatePermission = createPermission({
  name: 'llmProxy.localdevKey.rotate',
  attributes: { action: 'update' },
});

export const llmProxyLocaldevKeyRevokePermission = createPermission({
  name: 'llmProxy.localdevKey.revoke',
  attributes: { action: 'delete' },
});

export const llmProxyLocaldevKeyAdminReadPermission = createPermission({
  name: 'llmProxy.localdevKey.admin.read',
  attributes: { action: 'read' },
});

export const llmProxyLocaldevKeyAdminRevokePermission = createPermission({
  name: 'llmProxy.localdevKey.admin.revoke',
  attributes: { action: 'delete' },
});

export const llmProxyAppsKeyReadPermission = createPermission({
  name: 'llmProxy.appsKey.read',
  attributes: { action: 'read' },
});

export const llmProxyAppsKeyCreatePermission = createPermission({
  name: 'llmProxy.appsKey.create',
  attributes: { action: 'create' },
});

export const llmProxyAppsKeyRotatePermission = createPermission({
  name: 'llmProxy.appsKey.rotate',
  attributes: { action: 'update' },
});

export const llmProxyAppsKeyRevokePermission = createPermission({
  name: 'llmProxy.appsKey.revoke',
  attributes: { action: 'delete' },
});

export const llmProxyLocaldevKeyPermissions = [
  llmProxyLocaldevKeyReadPermission,
  llmProxyLocaldevKeyCreatePermission,
  llmProxyLocaldevKeyRotatePermission,
  llmProxyLocaldevKeyRevokePermission,
];

export const llmProxyAppsKeyPermissions = [
  llmProxyAppsKeyReadPermission,
  llmProxyAppsKeyCreatePermission,
  llmProxyAppsKeyRotatePermission,
  llmProxyAppsKeyRevokePermission,
];

export const llmProxyLocaldevKeyAdminPermissions = [
  llmProxyLocaldevKeyAdminReadPermission,
  llmProxyLocaldevKeyAdminRevokePermission,
];

export const llmProxyKeysPermissions = [
  ...llmProxyLocaldevKeyPermissions,
  ...llmProxyLocaldevKeyAdminPermissions,
  ...llmProxyAppsKeyPermissions,
];
